export default __webpack_public_path__ + "static/media/myca_wall.ccb82060.webp";